import { ChatCircleIcon, TrashIcon, PencilIcon } from '@phosphor-icons/react'
import { formatDistanceToNow } from 'date-fns'
import { ScoopButton, ScoopSpinner, ScoopText, ScoopRow, ScoopColumn } from '../../../../ui'
import { useModal, MODALS } from '../../../../modals'
import styles from './ChatListItem.module.scss'

export const ChatListItem = ({
    chat,
    isSelected = false,
    onClick,
    onDelete,
    onRename,
    showDeleteButton = false,
    isDeleting = false,
}) => {
    const deleteModal = useModal(MODALS.COMMON.DELETE)
    const textInputModal = useModal(MODALS.COMMON.TEXT_INPUT)

    const handleClick = (e) => {
        e.preventDefault()
        if (!isDeleting) {
            onClick?.(chat.chatID)
        }
    }

    const handleDeleteClick = async (e) => {
        e.preventDefault()
        e.stopPropagation()
        const confirmed = await deleteModal.show({
            title: 'Chat',
            description: `Are you sure you want to delete "${chat.title || 'Untitled Chat'}"? This action cannot be undone.`,
        })
        if (confirmed) {
            onDelete?.(chat.chatID)
        }
    }

    const handleEditClick = async (e) => {
        e.preventDefault()
        e.stopPropagation()
        const result = await textInputModal.show({
            title: 'Rename Chat',
            label: 'Chat Name',
            initialValue: chat.title || 'Untitled Chat',
            placeholder: 'Enter chat name',
        })
        if (result?.value && result.value !== chat.title) {
            onRename?.(chat.chatID, result.value)
        }
    }

    const formatTimeAgo = (timestamp) => {
        try {
            return formatDistanceToNow(new Date(timestamp), { addSuffix: true })
        } catch (error) {
            return ''
        }
    }

    return (
        <>
            <ScoopRow
                onClick={handleClick}
                className={`${styles.container} ${isSelected ? styles.selected : ''}`}
                align="center"
                gap={12}
            >
                {/* Chat Icon */}
                <ChatCircleIcon
                    size={18}
                    color={isSelected ? styles.colorPrimary : styles.colorTextSecondary}
                    weight={isSelected ? 'fill' : 'regular'}
                />

                {/* Chat Details */}
                <ScoopColumn className={styles.chatDetails}>
                    <ScoopText
                        className={`${styles.chatTitle} ${isSelected ? styles.selected : ''}`}
                    >
                        {chat.title || 'Untitled Chat'}
                    </ScoopText>

                    {/* Last message time */}
                    <span className={styles.timeText}>
                        {chat.lastMessageAt && formatTimeAgo(chat.lastMessageAt)}
                    </span>
                </ScoopColumn>

                {/* Action Buttons */}
                <ScoopRow align="center" gap={4} className={styles.actionButtons}>
                    {/* Edit Button */}
                    {!isDeleting && (
                        <ScoopButton
                            variant="text"
                            size="xxs"
                            className={`${styles.editButton} edit-button`}
                            onClick={handleEditClick}
                        >
                            <PencilIcon size={14} />
                        </ScoopButton>
                    )}
                    {/* Delete Button */}
                    {showDeleteButton &&
                        (isDeleting ? (
                            <div className={styles.loaderContainer}>
                                <ScoopSpinner size={14} />
                            </div>
                        ) : (
                            <ScoopButton
                                variant="text"
                                size="xxs"
                                className={`${styles.deleteButton} delete-button`}
                                onClick={handleDeleteClick}
                            >
                                <TrashIcon size={14} />
                            </ScoopButton>
                        ))}
                </ScoopRow>
            </ScoopRow>
        </>
    )
}
